module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.9109afaf.png";